NIRV._viewInbox = function () {
  var init = {};

  $('#main').addClass('inbox');

  init = {
    key: 'inbox.1',
    params: { state: 0, type: 0, completed: 0 },
    // name: NIRV.L.inbox,
    name: false,
    sortby: 'seq',
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '0'
  ) {
    init = {
      key: 'inbox.completed',
      params: { state: 0, completed: 1 },
      name: 'Done',
      sortby: 'seq',
    };
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  }
};

NIRV._viewFocus = function () {
  $('#main').addClass('focus');
  const filters = NIRV.currentfilters;
  const prefs = NIRV.prefs;
  const leaveCompleted = prefs.UIBLeaveCompletedInPlace && prefs.UIBLeaveCompletedInPlace.value === '1';
  const groupBy = prefs.UIBFocusGroupBy && prefs.UIBFocusGroupBy.value;

  function appendTasklist(key, params, name, sortby, addClass) {
    // Don't mutate the original params object
    const taskParams = Object.assign({}, params);
    if (leaveCompleted) delete taskParams.completed;
    const init = { key, params: taskParams, name, sortby };
    if (addClass) init.addClass = addClass;
    NIRV.tasklists[key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[key].recalc().render());
  }

  if (filters.due) {
    appendTasklist('focus.1', { focus: 1, completed: 0 }, 'Due', 'duedate');
    return;
  }

  if (groupBy === 'state') {
    appendTasklist('focus.inbox', { focus: 1, type: 0, state: 0, completed: 0 }, NIRV.L.inbox, 'seq');
    appendTasklist('focus.next', { focus: 1, type: 0, state: 1, completed: 0 }, NIRV.L.next, 'seq');
    appendTasklist('focus.later', { focus: 1, state: 5, completed: 0 }, 'Later', 'seq');
    appendTasklist('focus.waiting', { focus: 1, type: 0, state: 2, completed: 0 }, NIRV.L.waiting, 'seq');
    appendTasklist('focus.scheduled', { focus: 1, scheduledandrecurring: 1, completed: 0 }, NIRV.L.scheduled, 'startdate');
    appendTasklist('focus.someday', { focus: 1, state: 4, completed: 0 }, NIRV.L.someday, 'seq');

    const sortProjects = prefs.UISortProjects && prefs.UISortProjects.value === 'alpha' ? 'name' : 'seqt';
    appendTasklist('focus.activeprojects', { focus: 1, type: 1, state: 11, completed: 0 }, NIRV.L.activeprojects, sortProjects);
    appendTasklist('reference', { focus: 1, state: NIRV.CONST.REFERENCE }, 'Reference', 'seq', 'reference');

    // Removed suspended tasklist

    if (!leaveCompleted) {
      appendTasklist('focus.completed', { focus: 1, completed: 1 }, 'Done', 'completed');
    }
    return;
  }

  if (groupBy === 'parentid') {
    // Standalone: exclude tasks whose parent is a project (notparenttype: 1)
    appendTasklist('focus.standalone', { focus: 1, type: 0, top: 1, notparenttype: 1, completed: 0 }, 'Standalone Actions', 'seqt');
    const sortProjects = prefs.UISortProjects && prefs.UISortProjects.value === 'alpha' ? 'name' : 'seqt';
    appendTasklist('focus.projects', { focus: 1, type: 1, parentid: '', completed: 0 }, NIRV.L.projects, sortProjects);

    let projects = NIRV.projects();
    if (prefs.UISortProjects && prefs.UISortProjects.value === 'alpha') {
      projects = sortEntitiesBy(projects, 'name', 'asc', false);
    }
    for (let i = 0; i < projects.length; ++i) {
      const project = projects[i];
      appendTasklist(
        'focus.' + project.id,
        { focus: 1, type: 0, parentid: project.id, completed: 0 },
        project.name,
        sortProjects,
        'project'
      );
    }

    appendTasklist('reference', { focus: 1, state: NIRV.CONST.REFERENCE }, 'Reference', 'seq', 'reference');
    
    // Removed suspended tasklist

    if (!leaveCompleted) {
      appendTasklist('focus.completed', { focus: 1, completed: 1 }, 'Done', 'completed');
    }
    return;
  }

  // unified list
  appendTasklist('focus.todo', { focus: 1, completed: 0 }, '', 'seqt');
  // Removed suspended tasklist

  if (!leaveCompleted) {
    appendTasklist('focus.completed', { focus: 1, completed: 1 }, 'Done', 'completed');
  }
};

NIRV._viewNext = function () {
  var init = {};

  // group by project
  if (
    NIRV.prefs.UIBNextGroupBy &&
    NIRV.prefs.UIBNextGroupBy.value == 'parentid'
  ) {
    $('#main').addClass('next');
    // Show standalone and areafolder-children tasks (top: 1)
    init = {
      key: 'next.standalone',
      params: { state: 1, top: 1, notparenttype: 1, completed: 0 },
      name: 'Actions',
      sortby: 'seq',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    var projects = NIRV.projects();
    if (
      NIRV.prefs.UISortProjects &&
      NIRV.prefs.UISortProjects.value == 'alpha'
    ) {
      projects = sortEntitiesBy(projects, 'name', 'asc', false);
    }
    for (var i in projects) {
      if (projects[i].state == NIRV.CONST.ACTIVEPROJECT) {
        init = {
          key: 'next.' + projects[i].id,
          params: { state: 1, parentid: projects[i].id, completed: 0 },
          name: projects[i].name,
          addClass: 'project',
          sortby: 'seqp',
        };
        if (
          NIRV.prefs.UIBLeaveCompletedInPlace &&
          NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
        ) {
          delete init.params.completed;
        }
        NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
        $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
      }
    }

    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '0'
    ) {
      init = {
        key: 'next.completed',
        params: { state: 1, completed: 1 },
        name: 'Done',
        sortby: 'completed',
      };
      NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
      $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
    }
  }

  // group by sequential next actions
  else if (NIRV.prefs.UIBNextGroupBy && NIRV.prefs.UIBNextGroupBy.value == '') {
    $('#main').addClass('next2');
    init = {
      key: 'next.standalone',
      params: { state: 1, parentid: '', completed: 0 },
      name: 'Actions',
      sortby: 'seq',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    init = {
      key: 'next.seqentialdrilldown',
      params: { state: 1, top: 1, completed: 0 },
      name: 'Project Actions - Sequential Drilldown',
      sortby: 'seq',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '0'
    ) {
      init = {
        key: 'next.completed',
        params: { state: 1, completed: 1 },
        name: 'Done',
        sortby: 'completed',
      };
      NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
      $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
    }
  }

  // UNL
  else if (
    NIRV.prefs.UIBNextGroupBy &&
    NIRV.prefs.UIBNextGroupBy.value == 'none'
  ) {
    init = {
      key: 'next.todo',
      params: { state: 1, completed: 0 },
      name: 'Actions',
      sortby: 'seq',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '0'
    ) {
      init = {
        key: 'next.completed',
        params: { state: 1, completed: 1 },
        name: 'Done',
        sortby: 'completed',
      };
      NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
      $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
    }
  }
};

NIRV._viewLater = function () {
  var init = {};

  init = {
    key: 'later.tasks',
    params: { state: 5, type: 0, completed: 0 },
    name: 'Later',
    sortby: 'seq',
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'later.projects',
    params: { state: 5, type: 1, completed: 0 },
    name: 'Projects (Inactive)',
    sortby: 'seq',
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '0'
  ) {
    init = {
      key: 'later.completed',
      params: { state: 5, completed: 1 },
      name: 'Done',
      sortby: 'completed',
    };
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  }
};

NIRV._viewWaiting = function () {
  var init = {};

  init = {
    key: 'waiting.todo',
    params: { state: 2, completed: 0 },
    name: NIRV.L.waitingfor,
    sortby: 'seq',
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '0'
  ) {
    init = {
      key: 'waiting.completed',
      params: { state: 2, completed: 1 },
      name: 'Done',
      sortby: 'completed',
    };
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  }
};

NIRV._viewScheduled = function () {
  var init = {};

  $('#main').addClass('scheduled');

  init = {
    key: 'scheduled.thisweek',
    params: { completed: 0, scheduledandrecurring: 'thisweek' },
    name: 'This Week',
    sortby: 'startdate',
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'scheduled.nextweek',
    params: { completed: 0, scheduledandrecurring: 'nextweek' },
    name: 'Next Week',
    sortby: 'startdate',
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'scheduled.afternextweek',
    params: { completed: 0, scheduledandrecurring: 'afternextweek' },
    name: 'Future Dates',
    sortby: 'startdate',
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '0'
  ) {
    init = {
      key: 'scheduled.completed',
      params: { completed: 1, state: NIRV.CONST.SCHEDULED },
      name: 'Done',
      sortby: 'completed',
    };
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  }
};

NIRV._viewSomeday = function () {
  var init = {};

  $('#main').addClass('someday');

  // init = {
  //     key: '__state__4__type__0__completed__0',
  //     name: NIRV.L.someday,
  //     sortby: 'seq'
  // };
  // NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  // $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  //
  // init = {
  //     key: '__state__4__type__1__completed__0',
  //     name: 'Projects',
  //     sortby: 'seq'
  // };
  // NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  // $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  //
  // init = {
  //     key: '__state__4__completed__1',
  //     name: '&nbsp;',
  //     sortby: 'completed'
  // };
  // NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  // $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'someday.standalone',
    params: { state: 4, type: 0, top: 1, notparenttype: 1, completed: 0 },
    name: 'Actions',
    sortby: 'seq',
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'someday.projects',
    params: { state: 4, type: 1, completed: 0 },
    name: 'Projects',
    sortby: 'seq',
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  var projects = NIRV.projects();
  for (var i in projects) {
    if (projects[i].state == NIRV.CONST.ACTIVEPROJECT) {
      init = {
        key: 'someday.' + projects[i].id,
        params: {
          state: 4,
          type: 0,
          parentid: projects[i].id,
          completed: 0,
        },
        name: projects[i].name,
        addClass: 'project',
        sortby: 'seqp',
      };
      if (
        NIRV.prefs.UIBLeaveCompletedInPlace &&
        NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
      ) {
        delete init.params.completed;
      }
      NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
      $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
    }
  }

  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '0'
  ) {
    init = {
      key: 'someday.completed',
      params: { state: 4, completed: 1 },
      name: 'Done',
      sortby: 'completed',
    };
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  }
};

NIRV._viewProjects = function () {
  var init = {};

  $('#main').addClass('projects');
  $('#east h3.projects').addClass('on');

  var sortby_active =
    NIRV.prefs.UISortProjects && NIRV.prefs.UISortProjects.value == 'alpha'
      ? 'name'
      : 'seq';
  var sortby_inactive =
    NIRV.prefs.UISortProjects && NIRV.prefs.UISortProjects.value == 'alpha'
      ? 'name'
      : 'seq';
  var sortby_scheduled =
    NIRV.prefs.UISortProjects && NIRV.prefs.UISortProjects.value == 'alpha'
      ? 'name'
      : 'startdate';
  var sortby_someday =
    NIRV.prefs.UISortProjects && NIRV.prefs.UISortProjects.value == 'alpha'
      ? 'name'
      : 'seq';
  var sortby_completed =
    NIRV.prefs.UISortProjects && NIRV.prefs.UISortProjects.value == 'alpha'
      ? 'name'
      : 'completed';

  init = {
    key: 'projects.active',
    params: { type: 1, state: 11, completed: 0 },
    name: NIRV.L.activeprojects,
    sortby: sortby_active,
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'projects.inactive',
    params: { type: 1, state: 5, completed: 0 },
    name: NIRV.L.inactive,
    sortby: sortby_inactive,
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'projects.scheduled',
    params: { type: 1, scheduledandrecurring: 1, completed: 0 },
    name: NIRV.L.scheduled,
    sortby: sortby_scheduled,
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'projects.someday',
    params: { type: 1, state: 4, completed: 0 },
    name: NIRV.L.someday,
    sortby: sortby_someday,
  };
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '0'
  ) {
    init = {
      key: 'projects.completed',
      params: { type: 1, completed: 1, logged: 0 },
      name: 'Done',
      sortby: sortby_completed,
    };
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  }
};

NIRV._viewRefLists = function () {
  var init = {};

  $('#main').addClass('reflists');
  $('#east h3.reflists').addClass('on');

  var sortby_reflists =
    NIRV.prefs.UISortReflists && NIRV.prefs.UISortReflists.value == 'alpha'
      ? 'name'
      : 'seq';

  init = {
    key: 'reflists',
    params: { type: NIRV.CONST.REFLIST },
    name: 'Reference Lists',
    sortby: sortby_reflists,
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
};

NIRV._viewLogbook = function () {
  var init = {};

  $('#main').addClass('logbook');

  if (NIRV.taskcounts.collect > 0) {
    $('#tasklists').append(
      '<div class="toolbar"><a href="#" class="fn awesome primary" fn="NIRV.collectCompleted" p1="0">Log Completed (' +
        NIRV.taskcounts.collect +
        ')</a></div>'
    );
  }

  init = {
    key: 'logbook.today',
    params: { completed: 'today', logged: 1 },
    name: 'Today',
    sortby: 'completed',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'logbook.active',
    params: { completed: 'thisweek', logged: 1 },
    name: 'This Week',
    sortby: 'completed',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'logbook.lastweek',
    params: { completed: 'lastweek', logged: 1 },
    name: 'Last Week',
    sortby: 'completed',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'logbook.twoweeksplus',
    params: { completed: 'twoweeksplus', logged: 1 },
    name: 'Older',
    sortby: 'completed',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
};

NIRV._viewTrash = function () {
  var init = {};

  $('#main').addClass('trash');

  if (NIRV.taskcounts.trash > 0) {
    $('#tasklists').prepend(
      '<div class="toolbar"><a href="#" class="fn awesome primary" fn="NIRV.emptyTrash">Empty Trash</a></div>'
    );
  }

  init = {
    key: 'trash',
    params: { state: 6 },
    name: NIRV.L.trash,
    sortby: 'name',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
};

NIRV.view = function (what) {
  DEBUG && console.log('-----------------------\nNIRV.view(' + what + ')');
  $(window).scrollTop(0);

  if (NIRV.currentview != what) {
    NIRV.viewinit();
    NIRV.currentview = what;
    NIRV.storage.setItem('NIRV.currentview', NIRV.currentview);
  }
  NIRV.recalcWtasks();

  NIRV.filterForSelectedTags();
  $('#east h3').removeClass('on');
  $('#east span.tag').removeClass('on');
  $('#east li').removeClass('on');
  $('#east li[rel="' + NIRV.currentview + '"]').addClass('on');

  $('#main').removeClass(
    'inbox next next2 later waiting scheduled someday focus projects project inactive reflist logbook trash'
  );

  $('#tasklists').empty();

  NIRV.autosave = false;

  switch (what) {
    case 'inbox':
      NIRV._viewInbox();
      break;

    case 'focus':
      NIRV._viewFocus();
      break;

    case 'next':
      NIRV._viewNext();
      break;

    case 'later':
      NIRV._viewLater();
      break;

    case 'waiting':
      NIRV._viewWaiting();
      break;

    case 'scheduled':
      NIRV._viewScheduled();
      break;

    case 'someday':
      NIRV._viewSomeday();
      break;

    case 'projects':
      NIRV._viewProjects();
      break;

    case 'reflists':
      NIRV._viewRefLists();
      break;

    case 'logbook':
      NIRV._viewLogbook();
      break;

    case 'trash':
      NIRV._viewTrash();
      break;
  }

  NIRV.refreshAll();
  NIRV.autosave = true;
};

NIRV.viewproject = function (pid) {
  DEBUG &&
    console.log('-----------------------\nNIRV.viewproject( ' + pid + ' )');
  $(window).scrollTop(0);

  var init = {};
  var project = NIRV.tasks[pid];

  if (project === undefined) {
    location.hash = '#projects';
    return;
  }

  if (project.type == NIRV.CONST.REFLIST) {
    NIRV.viewreflist(pid);
    return;
  }

  if (NIRV.currentview != 'p' + pid) {
    NIRV.viewinit();
    NIRV.currentview = 'p' + pid;
    NIRV.storage.setItem('NIRV.currentview', NIRV.currentview);
  }
  NIRV.recalcWtasks();

  NIRV.filterForSelectedTags();

  $('#east h3').removeClass('on');
  $('#east span.tag').removeClass('on');
  $('#east li').removeClass('on');
  $('#east li[rel="' + NIRV.currentview + '"]').addClass('on');

  $('#main')
    .removeClass(
      'inbox next next2 later waiting scheduled someday focus projects project inactive reflist logbook trash'
    )
    .addClass('project');

  if (project.state != NIRV.CONST.ACTIVEPROJECT) {
    $('#main').addClass('inactive');
  }

  $('#tasklists').empty();

  NIRV.autosave = false;

  if (project.__isasequentialproject__()) {
    init = {
      key: 'project.nextsteps',
      params: { parentid: project.id, nextsteps: 1, completed: 0 },
      name: 'Next Up',
      addClass: 'project nextsteps',
      sortby: 'seqp',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    init = {
      key: 'project.later',
      params: { parentid: project.id, state: 5, completed: 0 },
      name: 'Later',
      addClass: 'project later',
      sortby: 'seqp',
    };
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    init = {
      key: 'project.repeating',
      params: { parentid: project.id, state: 9 },
      name: 'Repeating',
      addClass: 'project repeating',
      sortby: 'seqp',
    };
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    init = {
      key: 'project.someday',
      params: { parentid: project.id, state: 4, completed: 0 },
      name: NIRV.L.someday,
      addClass: 'project someday',
      sortby: 'seqp',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      init = {
        key: 'project.logged',
        params: { parentid: project.id, logged: 1 },
        name: 'Logged',
        addClass: 'project logged',
        sortby: 'completed',
      };
    } else {
      init = {
        key: 'project.completed',
        params: { parentid: project.id, completed: 1 },
        name: 'Done',
        addClass: 'project completed',
        sortby: 'completed',
      };
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  } else {
    init = {
      key: 'project.next',
      params: { parentid: project.id, state: 1, completed: 0 },
      name: 'Next',
      addClass: 'project next',
      sortby: 'seqp',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    init = {
      key: 'project.later',
      params: { parentid: project.id, state: 5, completed: 0 },
      name: 'Later',
      addClass: 'project later',
      sortby: 'seqp',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    init = {
      key: 'project.waiting',
      params: { parentid: project.id, state: 2, completed: 0 },
      name: NIRV.L.waiting,
      addClass: 'project waiting',
      sortby: 'seqp',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    init = {
      key: 'project.scheduled',
      params: {
        parentid: project.id,
        scheduledandrecurring: 1,
        completed: 0,
      },
      name: NIRV.L.scheduled,
      addClass: 'project scheduledandrecurring',
      sortby: 'startdate',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    init = {
      key: 'project.someday',
      params: { parentid: project.id, state: 4, completed: 0 },
      name: NIRV.L.someday,
      addClass: 'project someday',
      sortby: 'seqp',
    };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      delete init.params.completed;
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
    ) {
      init = {
        key: 'project.logged',
        params: { parentid: project.id, logged: 1 },
        name: 'Logged',
        addClass: 'project logged',
        sortby: 'completed',
      };
    } else {
      init = {
        key: 'project.completed',
        params: { parentid: project.id, completed: 1 },
        name: 'Done',
        addClass: 'project completed',
        sortby: 'completed',
      };
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  }

  NIRV.refreshAll();
  NIRV.autosave = true;
};

NIRV.viewreflist = function (pid) {
  DEBUG &&
    console.log('-----------------------\nNIRV.viewreflist(' + pid + ')');
  $(window).scrollTop(0);

  var init = {};
  var reflist = NIRV.tasks[pid];

  if (reflist === undefined) {
    location.hash = '#reflists';
    return;
  }

  if (reflist.type == NIRV.CONST.PROJECT) {
    NIRV.viewproject(pid);
    return;
  }

  if (NIRV.currentview != 'l' + pid) {
    NIRV.viewinit();
    NIRV.currentview = 'l' + pid;
    NIRV.storage.setItem('NIRV.currentview', NIRV.currentview);
  }
  NIRV.recalcWtasks();

  NIRV.filterForSelectedTags();

  $('#east h3').removeClass('on');
  $('#east span.tag').removeClass('on');
  $('#east li').removeClass('on');
  $('#east li[rel="' + NIRV.currentview + '"]').addClass('on');

  $('#main')
    .removeClass(
      'inbox next next2 later waiting scheduled someday focus projects project inactive reflist logbook trash'
    )
    .addClass('reflist');

  $('#tasklists').empty();

  NIRV.autosave = false;

  init = {
    key: 'reflist',
    params: { type: NIRV.CONST.REFITEM, parentid: reflist.id },
    name: '',
    addClass: 'reflist',
    sortby: 'seq',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  NIRV.refreshAll();
  NIRV.autosave = true;
};

NIRV.viewareafolder = function (id) {
  DEBUG && console.log('-----------------------\nNIRV.viewareafolder(' + id + ')');
  $(window).scrollTop(0);

  if (NIRV.currentview !== 'z' + id) {
    NIRV.viewinit();
    NIRV.currentview = 'z' + id;
    NIRV.storage.setItem('NIRV.currentview', NIRV.currentview);
  }

  NIRV.recalcWtasks();
  NIRV.filterForSelectedTags();

  $('#east h3').removeClass('on');
  $('#east span.tag').removeClass('on');
  $('#east li').removeClass('on');
  $('#east li[rel="' + NIRV.currentview + '"]').addClass('on');

  $('#main')
    .removeClass(
      'inbox next next2 later waiting scheduled someday focus projects project inactive reflist logbook trash'
    )
    .addClass('areafolder');

  $('#tasklists').empty();
  NIRV.autosave = false;

  const baseParams = { parentid: id, completed: 0 };

  const views = [
    { key: 'af.inbox', params: { ...baseParams, state: 0 }, name: NIRV.L.inbox, sortby: 'seq' },
    { key: 'af.next', params: { ...baseParams, state: 1 }, name: NIRV.L.next, sortby: 'seq' },
    { key: 'af.later', params: { ...baseParams, state: 5 }, name: 'Later', sortby: 'seq' },
    { key: 'af.waiting', params: { ...baseParams, state: 2 }, name: NIRV.L.waiting, sortby: 'seq' },
    { key: 'af.scheduled', params: { ...baseParams, scheduledandrecurring: 1 }, name: NIRV.L.scheduled, sortby: 'startdate' },
    { key: 'af.someday', params: { ...baseParams, state: 4 }, name: NIRV.L.someday, sortby: 'seq' },
    { key: 'af.projects', params: { ...baseParams, type: 1, state: 11 }, name: NIRV.L.activeprojects, sortby: 'seqt' }
  ];

  for (const view of views) {
    const params = { ...view.params };
    if (
      NIRV.prefs.UIBLeaveCompletedInPlace &&
      NIRV.prefs.UIBLeaveCompletedInPlace.value === '1'
    ) {
      delete params.completed;
    }
    NIRV.tasklists[view.key] = NIRV.Tasklist.clone({
      key: view.key,
      params,
      name: view.name,
      sortby: view.sortby
    });
    $('#tasklists').append(NIRV.tasklists[view.key].recalc().render());
  }

  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value === '0'
  ) {
    const completedKey = 'af.completed';
    NIRV.tasklists[completedKey] = NIRV.Tasklist.clone({
      key: completedKey,
      params: { parentid: id, completed: 1 },
      name: 'Done',
      sortby: 'completed'
    });
    $('#tasklists').append(NIRV.tasklists[completedKey].recalc().render());
  }

  NIRV.refreshAll();
  NIRV.autosave = true;
};

NIRV.viewtag = function viewtag(q) {
  DEBUG && console.log('-----------------------\nNIRV.viewtag(' + q + ')');

  var init = {};

  if (NIRV.currentview != 'g' + q) {
    NIRV.viewinit();
    NIRV.currentview = 'g' + q;
    NIRV.storage.setItem('NIRV.currentview', NIRV.currentview);
  }
  NIRV.recalcWtasks();

  NIRV.filterForSelectedTags();

  $('#east h3').removeClass('on');
  $('#east li').removeClass('on');
  $('#east li.tag').removeClass('on');
  if (q == '__ALL__') {
    $('#east li.tag.all').addClass('on');
  } else if (q == '__NONE__') {
    $('#east li.tag.none').addClass('on');
  } else {
    $('#east li.tag:econtains("' + q + '")').addClass('on');
  }

  $('#main').removeClass(
    'inbox next next2 later waiting scheduled someday focus projects project inactive reflist logbook trash'
  );

  $('#tasklists').empty();

  if (q.length == 0) return;

  NIRV.autosave = false;

  init = {
    key: 'tag.inbox',
    params: { completed: 0, state: 0, tag: q },
    name: NIRV.L.inbox,
    sortby: 'seq',
  };
  if (q == '__ALL__') {
    init.params = { completed: 0, state: 0 };
  }
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'tag.next',
    params: { completed: 0, state: 1, suspended: 0, tag: q },
    name: NIRV.L.next,
    sortby: 'seq',
  };
  if (q == '__ALL__') {
    init.params = { completed: 0, state: 1, suspended: 0 };
  }
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  // init = {
  //     key: 'tag.next.inactive',
  //     params: { completed:0, state:1, suspended:1, tag:q },
  //     name: NIRV.L.next + ' (inactive)',
  //     sortby: 'seq'
  // };
  // if (q == '__ALL__') { init.params = { completed:0, state:1, suspended: 1 }; }
  // NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  // $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'tag.later',
    params: { completed: 0, type: 0, state: 5, tag: q },
    name: 'Later',
    sortby: 'seq',
  };
  if (q == '__ALL__') {
    init.params = { completed: 0, type: 0, state: 5 };
  }
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    // key: '__type__0__state__2__tag__' + q,
    key: 'tag.waiting',
    params: { completed: 0, type: 0, state: 2, tag: q },
    name: NIRV.L.waiting,
    sortby: 'seq',
  };
  if (q == '__ALL__') {
    init.params = { completed: 0, type: 0, state: 2 };
  }
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'tag.scheduled',
    params: { completed: 0, scheduledandrecurring: 1, tag: q },
    name: NIRV.L.scheduled,
    sortby: 'startdate',
  };
  if (q == '__ALL__') {
    init.params = { completed: 0, type: 0, scheduledandrecurring: 1 };
  }
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'tag.someday',
    params: { completed: 0, state: 4, tag: q },
    name: NIRV.L.someday,
    sortby: 'seq',
  };
  if (q == '__ALL__') {
    init.params = { completed: 0, type: 0, state: 4 };
  }
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  var projects_sortby = 'seq';
  if (NIRV.prefs.UISortProjects && NIRV.prefs.UISortProjects.value == 'alpha') {
    projects_sortby = 'name';
  }

  init = {
    key: 'tag.projects',
    params: { completed: 0, state: 11, logged: 0, tag: q },
    name: NIRV.L.activeprojects,
    sortby: projects_sortby,
  };
  if (q == '__ALL__') {
    init.params = { completed: 0, type: 1, logged: 0 };
  }
  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '1'
  ) {
    delete init.params.completed;
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  var reflists_sortby = 'seq';
  if (NIRV.prefs.UISortReflists && NIRV.prefs.UISortReflists.value == 'alpha') {
    reflists_sortby = 'name';
  }

  init = {
    key: 'tag.reflist',
    params: { type: NIRV.CONST.REFLIST, tag: q },
    name: 'Reference Lists',
    addClass: 'reflist',
    sortby: reflists_sortby,
  };
  if (q == '__ALL__') {
    init.params = { type: NIRV.CONST.REFLIST };
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'tag.refitem',
    params: { type: NIRV.CONST.REFITEM, tag: q },
    name: 'Reference Items',
    addClass: 'refitem',
    sortby: 'name',
  };
  if (q == '__ALL__') {
    init.params = { type: NIRV.CONST.REFITEM };
  }
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  if (
    NIRV.prefs.UIBLeaveCompletedInPlace &&
    NIRV.prefs.UIBLeaveCompletedInPlace.value == '0'
  ) {
    init = {
      key: 'tag.completed',
      params: { completed: 1, logged: 0, trashed: 0, tag: q },
      name: 'Done',
      sortby: 'completed',
    };
    if (q == '__ALL__') {
      init.params = { completed: 1, logged: 0, trashed: 0 };
    }
    NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
    $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());
  }

  NIRV.refreshAll();
  NIRV.autosave = true;
};

NIRV.search = function search(q) {
  DEBUG && console.log('-----------------------\nNIRV.search(' + q + ')');
  $(window).scrollTop(0);

  var init = {};

  NIRV.currentview = 'search';
  NIRV.storage.setItem('NIRV.currentview', NIRV.currentview);
  NIRV.recalcWtasks();

  NIRV.filterForSelectedTags();

  $('#main').removeClass(
    'inbox next next2 later waiting scheduled someday focus projects project inactive reflist logbook trash'
  );

  $('#east h3').removeClass('on');
  $('#east li').removeClass('on');
  $('#east span.tag').removeClass('on');

  $('#tasklists').empty();

  if (q.length == 0) return;

  NIRV.autosave = false;

  init = {
    // key: '__state__0__search__' + q,
    key: 'search.inbox',
    params: { state: 0, search: q },
    name: NIRV.L.inbox,
    sortby: 'name',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    // key: '__state__1__search__' + q,
    key: 'search.next',
    params: { state: 1, search: q },
    name: NIRV.L.next,
    sortby: 'name',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    // key: '__type__0__state__5__search__' + q,
    key: 'search.later',
    params: { state: 5, search: q },
    name: 'Later',
    sortby: 'name',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    // key: '__type__0__state__2__search__' + q,
    key: 'search.waiting',
    params: { type: 0, state: 2, search: q },
    name: NIRV.L.waiting,
    sortby: 'name',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    // key: '__type__0__scheduledandrecurring__1__search__' + q,
    key: 'search.scheduled',
    params: { type: 0, scheduledandrecurring: 1, search: q },
    name: NIRV.L.scheduled,
    sortby: 'name',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    // key: '__type__0__state__4__search__' + q,
    key: 'search.someday',
    params: { type: 0, state: 4, search: q },
    name: NIRV.L.someday,
    sortby: 'name',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    // key: '__type__1__logged__0__search__' + q,
    key: 'search.projects',
    params: { type: 1, logged: 0, search: q },
    name: NIRV.L.projects,
    sortby: 'name',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'reflist',
    params: { type: NIRV.CONST.REFLIST, search: q },
    name: 'Reference Lists',
    addClass: 'reflist',
    sortby: 'seq',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    key: 'refitem',
    params: { type: NIRV.CONST.REFITEM, search: q },
    name: 'Reference',
    addClass: 'refitem',
    sortby: 'name',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  init = {
    // key: '__state__7__search__' + q,
    key: 'search.logbook',
    params: { state: 7, search: q },
    name: NIRV.L.logbook,
    sortby: 'name',
  };
  NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  // init = {
  //     // key: '__state__6__search__' + q,
  //     key: 'search.trash',
  //     params: { state:6, search:q },
  //     name: NIRV.L.trash,
  //     sortby: 'name'
  // };
  // NIRV.tasklists[init.key] = NIRV.Tasklist.clone(init);
  // $('#tasklists').append(NIRV.tasklists[init.key].recalc().render());

  // NIRV.refreshCbar();
  // NIRV.refreshMain();
  // NIRV.hideEmptyTasklists();
  NIRV.refreshAll();
  NIRV.autosave = true;
};

